export const LISTING_CARD_CLICK_EVENT = 'listing.card.clicked';

export function normalizeAnalyticsListingId(value) {
  const normalized = typeof value === 'string' ? value.trim() : String(value || '').trim();
  if (!normalized || normalized.startsWith('fallback-') || normalized.startsWith('empty-')) {
    return null;
  }
  return normalized;
}

export function buildListingCardAnalyticsMetadata({
  context,
  section,
  variant,
  index,
  targetPath,
  pathname,
  tier,
} = {}) {
  const resolvedContext = context || section || null;
  const resolvedSection = section || context || null;

  return {
    context: resolvedContext,
    section: resolvedSection,
    variant: variant || null,
    index: Number.isInteger(index) ? index : null,
    tier: tier || null,
    pathname: pathname || '/',
    targetPath: targetPath || null,
  };
}
